<div class="c-modal__message d-flex">
  <span *ngIf="!url">{{ data }}</span>
  <ng-container *ngIf="url">
    <a [href]="url" target="_blank" class="c-link c-link--primary -blue d-flex align-items-baseline ml-5">
      <span class="mr-5">{{ data }}</span>
      <p500-ui-icon name="link"></p500-ui-icon>
    </a>
  </ng-container>
</div>
